export function sanitizeEmbedUrl(raw, allowedBase) {
  if (!raw || !allowedBase) return "";
  const value = String(raw).trim();
  // Zep opens the home app with embed=1; that must never become an iframe src.
  if (!value || value === "1" || value === "0" || value === "true" || value === "false") {
    return "";
  }
  if (!/^https?:\/\//i.test(value) && !value.startsWith("/")) {
    return "";
  }
  try {
    const embed = new URL(value, String(allowedBase));
    const allowed = new URL(String(allowedBase), window.location.origin);
    if (embed.origin !== allowed.origin) return "";
    if (embed.protocol !== "http:" && embed.protocol !== "https:") return "";
    if (embed.href.length > 500) return "";
    if (embed.pathname === "/1") return "";
    return `${embed.origin}${embed.pathname}${embed.search}`;
  } catch {
    return "";
  }
}

export function readIframeUrl(root, app) {
  const fallback = sanitizeEmbedUrl(app && app.url, app && app.url);
  const iframe = root && root.querySelector(".app-frame");
  if (!iframe) return fallback;

  const allowedBases = [app && app.url, window.location.origin].filter(Boolean);
  try {
    const href = iframe.contentWindow && iframe.contentWindow.location.href;
    for (const base of allowedBases) {
      const clean = sanitizeEmbedUrl(href, base);
      if (clean) return clean;
    }
  } catch {
    // Cross-origin until the iframe is served on the same origin.
  }

  for (const base of allowedBases) {
    const fromSrc = sanitizeEmbedUrl(iframe.src, base);
    if (fromSrc) return fromSrc;
  }
  return fallback;
}

export function resolveInvitedIframeSrc(app) {
  const params = new URLSearchParams(window.location.search);
  const raw = params.get("iframeUrl") || "";
  const fromInvite =
    sanitizeEmbedUrl(raw, app && app.url) ||
    sanitizeEmbedUrl(raw, window.location.origin);
  if (fromInvite) return fromInvite;
  return "";
}
